export default {
  ENTER_CREATE_CASE: { name: "ENTER_CREATE_CASE" },
  CREATE_CASE: { name: "CREATE_CASE" },
  SUBMIT_CASE: { name: "SUBMIT_CASE" },
  DELETE_CASE: { name: "DELETE_CASE" }
};
